import { render, staticRenderFns } from "./BSelector.vue?vue&type=template&id=7be1c83f&"
import script from "./BSelector.vue?vue&type=script&lang=js&"
export * from "./BSelector.vue?vue&type=script&lang=js&"
import style0 from "./BSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports